import { useField, UseFieldConfig, FieldRenderProps } from 'react-final-form';

export function createTypedUseField<FormValues>() {
  return function useTypedField<K extends keyof FormValues>(
    name: K,
    config?: UseFieldConfig<FormValues[K]>,
  ): FieldRenderProps<FormValues[K], HTMLElement> {
    return useField<FormValues[K]>(name as string, config);
  };
}

export function typedUseField<FormValues, K extends keyof FormValues>(
  name: K,
  config?: UseFieldConfig<FormValues[K]>,
): FieldRenderProps<FormValues[K], HTMLElement> {
  return useField<FormValues[K]>(name as string, config);
}

export function useTypedFormValue<FormValues, K extends keyof FormValues>(
  name: K,
  config?: UseFieldConfig<FormValues[K]>,
): FormValues[K] {
  const { input } = useField<FormValues[K]>(name as string, {
    subscription: { value: true },
    ...config,
  });

  return input.value;
}

export function createTypedUseFormValue<FormValues>() {
  return function useFormValue<K extends keyof FormValues>(
    name: K,
    config?: UseFieldConfig<FormValues[K]>,
  ): FormValues[K] {
    const { input } = useField<FormValues[K]>(name as string, {
      subscription: { value: true },
      ...config,
    });

    return input.value;
  };
}

export function createTypedUseFormError<FormValues>() {
  return function useFormValue<K extends keyof FormValues>(name: K, config?: UseFieldConfig<FormValues[K]>) {
    const { meta } = useField<FormValues[K]>(name as string, {
      subscription: { error: true, touched: true },
      ...config,
    });

    return {
      error: meta.error,
      touched: meta.touched,
    };
  };
}
